import { generateEventId } from '../../utils/string';

const acuityAnalytics = ({ appointmentType = '', bookingID = '' }) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const uniqueEventID = generateEventId();
	let value = 0;
	if (appointmentType === 'Bespoke Consultation') value = 10000;
	if (appointmentType === 'Bespoke Shirt Consultation') value = 3000;

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'acuity_conversion',
		ecommerce: {
			'x-fb-event_id': uniqueEventID,
			appointment_type: appointmentType,
			transaction_id: bookingID,
			value,
			currency: 'SEK',
		},
	});
};

export default acuityAnalytics;
